// action type for logging in
export const LOGIN_USER = "LOGIN_USER";
export const LOGOUT_USER = "LOGOUT_USER";
export const TOKEN_REFRESH = "TOKEN_REFRESH";